import { BrowserRouter as Router } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';

// Router
import AppRouter from '@/routes';

/**
 * Query Client Configuration
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

/**
 * Main Application Component
 * Enterprise-level React application with:
 * - Centralized routing configuration
 * - React Query for data fetching
 * - Lazy loading for optimal performance
 * - Route-based code splitting
 */
function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <AppRouter />
      </Router>
    </QueryClientProvider>
  );
}

export default App;
